<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gOkD1m/images/e9781439611975_cover.jpg?1684306039875" alt="This image is the cover for the book The Boats and Ports of Lake Winnipesaukee"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Boats and Ports of Lake Winnipesaukee
      </h1>
      <p class="bookDescription body article font2">
        <p>The Lake Winnipesaukee region has a long and well-deserved history as one of the most scenic and popular areas in New England. The lake's appeal lies in its stunning mountain ranges, its fleet of steamboats, and its colorful islands and port towns. Boats have been an integral part of the region's economy since the early settlement of the area, providing transportation for work and leisure.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce D. Heald
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b5cf34a